export const SET_CONTEXT_UPDATERS = "SET_CONTEXT_UPDATERS";
export const ADD_CONTEXT_UPDATER = "ADD_CONTEXT_UPDATER";
export const REMOVE_CONTEXT_UPDATER = "REMOVE_CONTEXT_UPDATER";
export const UPDATE_CONTEXT_UPDATER = "UPDATE_CONTEXT_UPDATER";
export const ADD_UPDATER_CONTEXT_PROPERTY = "ADD_UPDATER_CONTEXT_PROPERTY";
export const REMOVE_UPDATER_CONTEXT_PROPERTY = "REMOVE_UPDATER_CONTEXT_PROPERTY";
export const UPDATE_UPDATER_CONTEXT_PROPERTY = "UPDATE_UPDATER_CONTEXT_PROPERTY";
export const SET_UPDATER_CONTEXT_PROPERTIES = "SET_UPDATER_CONTEXT_PROPERTIES";

export function setContextUpdaters(contextUpdaters) {
    return dispatch => dispatch({
        type: SET_CONTEXT_UPDATERS,
        contextUpdaters
    });
}

export function addContextUpdater(contextUpdater) {
    return dispatch => dispatch({
        type: ADD_CONTEXT_UPDATER,
        contextUpdater
    });
}

export function removeContextUpdater(index) {
    return dispatch => dispatch({
        type: REMOVE_CONTEXT_UPDATER,
        index
    });
}
export function updateContextUpdater(index, property, value) {
    return dispatch => dispatch({
        type: UPDATE_CONTEXT_UPDATER,
        index,
        property,
        value
    });
}
export function addUpdaterContextProperty(index, contextProperty) {
    return dispatch => dispatch({
        type: ADD_UPDATER_CONTEXT_PROPERTY,
        index,
        contextProperty
    });
}

export function removeUpdaterContextProperty(updaterIndex, propertyIndex) {
    return dispatch => dispatch({
        type: REMOVE_UPDATER_CONTEXT_PROPERTY,
        updaterIndex,
        propertyIndex
    });
}
export function updateUpdaterContextProperty(updaterIndex, propertyIndex, property, value) {
    return dispatch => dispatch({
        type: UPDATE_UPDATER_CONTEXT_PROPERTY,
        updaterIndex,
        propertyIndex,
        property,
        value
    });
}
export function setUpdaterContextProperties(updaterIndex, contextProperties) {
    return dispatch => dispatch({
        type: SET_UPDATER_CONTEXT_PROPERTIES,
        updaterIndex,
        contextProperties
    });
}